$(function(){

	var jsonData = {
	  "apikey": "2e480ae1f268977bd40eb79c1f9d64bb",
	  "Password": "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" }

	var products_json = '/products.json?limit=250';

	if($('.product-area').length)
	{
		$('.package-addtocart').css('visibility', 'visible');

		let package_html = '';
		let current_product_id = $('.product-area').attr('data-id');

		if($('.product-area').attr('data-tags').indexOf('Hope') > -1 || $('.product-area').attr('data-tags').indexOf('Murad') > -1 || $('.product-area').attr('data-tags').indexOf('Earth') > -1)
		{
			$.ajax({
				url: products_json,
				type: "get",
				dataType: "json",
				data: jsonData,
				success: function (data) {
					products = data.products;

					let pckg;
					let pckg_title;
					let pckg_price;
					let pckg_description;
					let pckg_visual;

					let pckg_options_title;
					let pckg_options_values;
					let pckg_options = '';
					let pckg_options_html = '';
					let pckg_option;
					let pckg_option_id;

					for(let i=0;i<products.length;i++)
					{

						if(products[i].title === 'Relax & Recharge')
						{	
							pckg = products[i];

							pckg_title = products[i].title;
							pckg_price = '£'+products[i].variants[0].price.split('.')[0];
							pckg_description = products[i].body_html;
							pckg_visual = products[i].variants[0].featured_image.src;

							pckg_options_title = pckg.options[0].name;
							pckg_options_values = pckg.options[0].values;

							for(let v=0; v<pckg_options_values.length;v++)
							{
								if(pckg_options_values[v].indexOf(' ') > -1)
								{
									pckg_option = pckg_options_values[v].split(' ').join('-');
								}else
								{
									pckg_option = pckg_options_values[v];
								}

								for(let vo=0;vo<products[i].variants.length;vo++)
								{
									if(products[i].variants[vo].option1 === pckg_options_values[v])
									{
										pckg_option_id = products[i].variants[vo].id;
									}
								}

								pckg_option = pckg_option.toLowerCase();
								pckg_options_html += '<li data-id="'+pckg_option_id+'" value="'+pckg_option+'">'+pckg_options_values[v]+'</li>';
							}

							package_html += '<div class="package">'+
								'<div class="pckg-product">'+
									'<div class="pckg-product_title">'+
										'<div class="pckg-product_name">'+pckg_title+'</div>'+
										'<div class="pckg-product_price">+ '+pckg_price+'</div>'+
										'<button><span class="add">Add</span><span class="added">Added</span><span class="change">Change</span><span class="close">Close</span></button>'+
									'</div>'+
									'<div class="pckg-product_content">'+
										'<div class="pckg-info"><div class="pckg-info-outer"><div class="pckg-info-inner">'+pckg_description+'</div></div><span class="pckg-readmore">Read more</span></div>'+
										'<div class="pckg-visual"><img src="'+pckg_visual+'" alt=""></div>'+
										'<div class="pckg-select-html">'+
											'<span><strong>Choose your scent:</strong><span class="chosen">'+pckg_options_values[0]+'</span></span>'+
											'<ul>'+pckg_options_html+'</ul>'+
										'</div>'+
										'<div class="pckg-select-info"></div>'+
										'<button class="remove"><span class="add-m">Add</span><span class="change-m">Change</span><span class="remove-m">Remove</span></button>'+
									'</div>'+
								'</div>'+
                            
								'<div class="pckg-note">'+
									'<div class="pckg-note_title">'+
										'<div class="pckg-product_name">Handwritten gift note</div>'+
										'<button><span class="add">Add</span><span class="added">Added</span><span class="change">Change</span><span class="close">Close</span></button>'+
									'</div>'+
									'<div class="pckg-note_content">'+
										'<form method="get" action="/"><textarea id="handwritten_note"></textarea></form>'+
										'<button class="remove"><span class="add-m">Add</span><span class="change-m">Change</span><span class="remove-m">Remove</span></button>'+
									'</div>'+
								'</div>'+
							'</div>';
						}
					}

					$('.product-area__details__inner .product-area__details__header').after(package_html);
					if($(window).width()<768)
					{
						$('.product-detail__form').prepend(package_html);
					}


					$('.package-descriptions .package-item').each(function(){
						if($(this).find('.package-title').text() === $('.pckg-product .pckg-select-html span.chosen').text())
						$('.pckg-select-info').text($(this).find('.package-info').text());
					})
					$('.pckg-select-html ul li').eq(0).addClass('active');

				},
				error: function(request, error) {
					console.log(arguments);
			     	console.log(" Can't do because: " + error);
				}
			});
		}


		$('body').on('click', '.pckg-product_title button', function(){
			$('.pckg-product_content').slideToggle();
			$('.pckg-product').toggleClass('opened');
		})
		$('body').on('click', '.pckg-note_title button', function(){
			$('.pckg-note_content').slideToggle();
			$('.pckg-note').toggleClass('opened');
		})

		$('body').on('click', '.pckg-product button.remove', function(){
			if(!$(this).hasClass('change'))
			{
				if(!$(this).parents('.pckg-product').hasClass('added'))
				{
					$(this).parents('.pckg-product').addClass('added');
				}else
				{
					$(this).parents('.pckg-product').removeClass('added');
				}
			}else
			{
				$('.package .pckg-product button.remove').removeClass('change');
				$('.package .pckg-product button.remove .remove-m').show();
				$('.package .pckg-product button.remove .change-m').hide();
			}

			$('.pckg-product_content').slideUp();
			$(this).parents('.pckg-product').removeClass('opened');
		})
		$('body').on('click', '.pckg-note button.remove', function(){
			if(!$(this).hasClass('change'))
			{
				if(!$(this).parents('.pckg-note').hasClass('added'))
				{
					$(this).parents('.pckg-note').addClass('added');
				}else
				{
					$(this).parents('.pckg-note').removeClass('added');
					$('.pckg-note_content textarea').val('');
				}
			}else
			{
				$('.package .pckg-note button.remove').removeClass('change');
				$('.package .pckg-note button.remove .remove-m').show();
				$('.package .pckg-note button.remove .change-m').hide();
			}

			$('.pckg-note_content').slideUp();
			$(this).parents('.pckg-note').removeClass('opened');
		})


		$('body').on('click', '.pckg-select-html > span', function(){
			$('body .pckg-select-html ul').addClass('on-screen');
		})
		$('body').on('click', '.pckg-select-html ul li', function(){
			let text = $(this).text();

			$(this).parent().find('li').removeClass('active');
			$(this).addClass('active');

			$('.pckg-select-html span.chosen').text(text);
			$('body .pckg-select-html ul').removeClass('on-screen');

			$('.package-descriptions .package-item').each(function(){
				if($(this).find('.package-title').text() === text)
				$('.pckg-select-info').text($(this).find('.package-info').text());
			})

			if($(this).parents('.pckg-product').hasClass('added'))
			{
				$('.package .pckg-product button.remove').addClass('change');
				$('.package .pckg-product button.remove .remove-m').hide();
				$('.package .pckg-product button.remove .change-m').show();
			}
		})

		$('body').on('change keyup paste', '#handwritten_note', function() {
		    if($(this).parents('.pckg-note').hasClass('added'))
			{
				$('.package .pckg-note button.remove').addClass('change');
				$('.package .pckg-note button.remove .remove-m').hide();
				$('.package .pckg-note button.remove .change-m').show();
			}
		});

		$('body').on('click', '.pckg-info > .pckg-readmore', function(){
			let $this = $(this)
			if($this.text() === 'Read more')
			{
				$this.text('Read less');
				$(this).parent().find('.pckg-info-outer').animate({
				    height: $(this).parent().find('.pckg-info-outer .pckg-info-inner').outerHeight()
			  	}, 500);
			}else
			{
		    	$this.text('Read more');
				$(this).parent().find('.pckg-info-outer').animate({
				    height: '3em'
			  	}, 500);
			}
		})


		$('body').on('click', '.package-addtocart', function(e){
			e.preventDefault();
			e.stopPropagation();

			let package = $('.package');
			let package_img;
			let package_name;
			let package_option;
			let package_var_id;
			let package_note = '—';

			let cart_product_html = '';

			if(package.find('.pckg-product').hasClass('added'))
			{
				package_img = package.find('.pckg-product .pckg-visual img').attr('src');
				package_name = package.find('.pckg-product .pckg-product_title .pckg-product_name').text();
				package_option= package.find('.pckg-product .pckg-select-html ul li.active').text();
				package_var_id = package.find('.pckg-product .pckg-select-html ul li.active').attr('data-id');

				if(package.find('.pckg-note').hasClass('added'))
				{
					package_note = package.find('.pckg-note textarea').val();
				}

				cart_product_html += '<div class="cart-product"><div class="cart-product__image"><img src="'+package_img+'" alt="'+package_name+'"></div><div class="cart-product__content"><p class="cart-product__content__title">'+package_name+'</p><p class="cart-product__content__option">'+package_option+'</p></div></div>';

				let wanted = [];

				if(package_note === '—')
				{
					wanted.push({
						quantity:1,
						id: package_var_id
					});
				}else
				{
					wanted.push({
						quantity:1,
						id: package_var_id,
						properties: {
					      'note' : package_note
					    }
					});
				}

				jQuery.ajax({
					type: 'POST',
					url: '/cart/add.js',
					data: {
						items: wanted
					},
					dataType: 'json',           
					success: function() {
						$('body').find('.product-detail__form__action button[type="submit"]').trigger('click');

						setTimeout(function(){
							$('#added-to-cart .cart-product').after(cart_product_html);
						}, 500);
					},
					error: function(response) {
						console.log(response);
					}
				});
			}else
			{
				$('body').find('.product-detail__form__action button[type="submit"]').trigger('click');
			}
		})
	}

	if(window.location.pathname === '/cart')
	{
		jQuery.ajax({
			type: 'GET',
			url: '/cart.js',
			dataType: 'json',           
			success: function(data) {
				for(let ci=0;ci<data.items.length;ci++)
				{
					if(data.items[ci].properties !== null && data.items[ci].properties.note !== undefined)
					{
						$('.item[data-id="'+data.items[ci].id+'"] .col-notimage .desc .title').after('<div class="line-items"><div class="note"><strong>Note:</strong> '+data.items[ci].properties.note+'</div></div>');
					}
				}
			},
			error: function(response) {
				console.log(response);
			}
		});
	}

});